/* WALLY one-pager: tabs, reveal-on-scroll, subtle sticky reserve bar. */
(function () {
  'use strict';
  // Mark that JS is ready — enables reveal-on-scroll opacity:0 initial state.
  document.documentElement.classList.add('js');

  // ── Tabs ──────────────────────────────────────────
  document.querySelectorAll('[data-wally-tabs]').forEach(function (root) {
    var tabs = root.querySelectorAll('[data-wally-tab]');
    var panels = root.querySelectorAll('[data-wally-panel]');
    tabs.forEach(function (tab) {
      tab.addEventListener('click', function () {
        var target = tab.getAttribute('data-wally-tab');
        tabs.forEach(function (t) {
          t.classList.toggle('is-active', t === tab);
          t.setAttribute('aria-selected', t === tab ? 'true' : 'false');
        });
        panels.forEach(function (p) {
          var match = p.getAttribute('data-wally-panel') === target;
          p.classList.toggle('is-active', match);
          p.hidden = !match;
        });
      });
    });
  });

  // ── Reveal on scroll (respects prefers-reduced-motion) ──
  if (!window.matchMedia('(prefers-reduced-motion: reduce)').matches && 'IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) {
          e.target.classList.add('is-revealed');
          io.unobserve(e.target);
        }
      });
    }, { rootMargin: '-40px 0px', threshold: 0.08 });
    document.querySelectorAll('[data-wally-reveal]').forEach(function (el) { io.observe(el); });
  } else {
    document.querySelectorAll('[data-wally-reveal]').forEach(function (el) { el.classList.add('is-revealed'); });
  }

  // ── v21 reveal-on-scroll (.reveal → .is-visible). Mirrors the v21 page's own
  //    script, which we don't bundle. Fallback reveals all if IO/reduced-motion. ──
  (function () {
    var els = document.querySelectorAll('.reveal');
    if (!els.length) return;
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches || !('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('is-visible'); });
      return;
    }
    var rio = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('is-visible'); rio.unobserve(e.target); }
      });
    }, { rootMargin: '-40px 0px', threshold: 0.08 });
    els.forEach(function (el) { rio.observe(el); });
  })();

  // ── Hero image gallery (thumbnail click swaps main) ──
  document.querySelectorAll('.wally-hero__gallery').forEach(function (gallery) {
    var main = gallery.querySelector('.wally-hero__gallery-main');
    var mainImg = main && main.querySelector('img, picture img');
    var thumbs = gallery.querySelectorAll('.wally-hero__thumb');
    if (!mainImg || !thumbs.length) return;
    thumbs.forEach(function (t, idx) {
      t.setAttribute('role', 'button');
      t.setAttribute('tabindex', '0');
      var activate = function () {
        var tPic = t.querySelector('picture');
        var tImg = t.querySelector('img, picture img');
        if (!tImg) return;
        thumbs.forEach(function (x) { x.classList.remove('is-active'); });
        t.classList.add('is-active');
        // Swap the MAIN <picture>'s <source> srcsets too — otherwise the browser
        // keeps using the thumb's low-res webp source and clicks look broken.
        var mainPic = main.querySelector('picture');
        if (mainPic && tPic) {
          var mainSources = mainPic.querySelectorAll('source');
          var tSources = tPic.querySelectorAll('source');
          mainSources.forEach(function (ms) {
            var match = Array.prototype.find.call(tSources, function (ts) { return ts.type === ms.type; });
            if (match) {
              ms.srcset = match.srcset;
              if (match.sizes) ms.sizes = match.sizes;
            }
          });
        }
        var tJpgSrcset = tImg.getAttribute('srcset');
        if (tJpgSrcset) {
          mainImg.srcset = tJpgSrcset;
          if (tImg.sizes) mainImg.sizes = tImg.sizes;
        }
        mainImg.src = tImg.currentSrc || tImg.src;
      };
      t.addEventListener('click', activate);
      t.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); activate(); }
      });
    });
  });

  // ── Sticky reserve bar (shows after user scrolls past hero CTA) ──
  var bar = document.querySelector('[data-wally-sticky-bar]');
  var heroTrigger = document.querySelector('[data-wally-hero-cta]');
  if (bar && heroTrigger && 'IntersectionObserver' in window) {
    var barIo = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        bar.classList.toggle('is-visible', !e.isIntersecting && e.boundingClientRect.top < 0);
      });
    }, { threshold: 0 });
    barIo.observe(heroTrigger);
  }

  // ── Generic gallery (data-attribute driven; used by wally2 buy box) ──
  // Markup: [data-wally-gallery] > [data-wally-gallery-main] (img/picture)
  //          + [data-wally-gallery-thumb] buttons (each with img/picture).
  document.querySelectorAll('[data-wally-gallery]').forEach(function (gallery) {
    var main = gallery.querySelector('[data-wally-gallery-main]');
    var mainImg = main && (main.matches('img') ? main : main.querySelector('img'));
    var thumbs = gallery.querySelectorAll('[data-wally-gallery-thumb]');
    if (!mainImg || !thumbs.length) return;
    thumbs.forEach(function (t) {
      var activate = function () {
        var tImg = t.querySelector('img');
        if (!tImg) return;
        thumbs.forEach(function (x) { x.classList.remove('is-active'); x.setAttribute('aria-current', 'false'); });
        t.classList.add('is-active');
        t.setAttribute('aria-current', 'true');
        var mainPic = main.querySelector('picture');
        var tPic = t.querySelector('picture');
        if (mainPic && tPic) {
          var mainSources = mainPic.querySelectorAll('source');
          var tSources = tPic.querySelectorAll('source');
          mainSources.forEach(function (ms) {
            var match = Array.prototype.find.call(tSources, function (ts) { return ts.type === ms.type; });
            if (match) { ms.srcset = match.srcset; if (match.sizes) ms.sizes = match.sizes; }
          });
        }
        var tSrcset = tImg.getAttribute('srcset');
        // Keep the MAIN image's own `sizes` (≈50vw) — do NOT copy the thumb's tiny
        // `sizes` (160px), which made the browser pick a low-res candidate (blurry preview, Suzy H3).
        if (tSrcset) { mainImg.srcset = tSrcset; }
        mainImg.src = tImg.currentSrc || tImg.src;
        if (tImg.alt) mainImg.alt = tImg.alt;
      };
      t.addEventListener('click', activate);
      t.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); activate(); }
      });
    });

    // Prev/next arrows on the main image -> advance the active thumb (Suzy R2)
    gallery.querySelectorAll('[data-wally-gallery-arrow]').forEach(function (arrow) {
      arrow.addEventListener('click', function () {
        var list = Array.prototype.slice.call(thumbs);
        var cur = list.findIndex(function (x) { return x.classList.contains('is-active'); });
        if (cur < 0) cur = 0;
        var dir = arrow.getAttribute('data-wally-gallery-arrow') === 'prev' ? -1 : 1;
        list[(cur + dir + list.length) % list.length].click();
      });
    });
  });

  // ── Auto-scrolling carousel (GWU photo strip) ──
  // Markup: [data-wally-carousel] > [data-wally-carousel-track] with the items
  // duplicated once in Liquid for a seamless loop. Pauses on hover.
  (function () {
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    document.querySelectorAll('[data-wally-carousel]').forEach(function (root) {
      var track = root.querySelector('[data-wally-carousel-track]');
      if (!track) return;
      var speed = parseFloat(root.getAttribute('data-wally-carousel-speed')) || 60; // px/sec
      var offset = 0, last = null, paused = false;
      root.addEventListener('mouseenter', function () { paused = true; });
      root.addEventListener('mouseleave', function () { paused = false; });
      function tick(now) {
        if (last == null) last = now;
        var dt = (now - last) / 1000; last = now;
        if (!paused) {
          offset += speed * dt;
          var half = track.scrollWidth / 2;
          if (half > 0 && offset >= half) offset -= half;
          track.style.transform = 'translateX(' + (-offset) + 'px)';
        }
        requestAnimationFrame(tick);
      }
      requestAnimationFrame(tick);
    });
  })();

  // ── Product image lightbox (click main image → fullscreen with prev/next) ──
  (function () {
    var lb = document.querySelector('[data-wally-lightbox]');
    if (!lb) return;
    var slides = lb.querySelectorAll('[data-lb-slide]');
    var counter = lb.querySelector('[data-lb-counter]');
    var total = slides.length;
    var idx = 0;

    function show(i) {
      idx = (i + total) % total;
      slides.forEach(function (s, n) { s.classList.toggle('is-active', n === idx); });
      if (counter) counter.textContent = (idx + 1) + ' / ' + total;
    }
    function open(i) {
      show(i || 0);
      lb.hidden = false;
      lb.setAttribute('aria-hidden', 'false');
      document.documentElement.style.overflow = 'hidden';
    }
    function close() {
      lb.hidden = true;
      lb.setAttribute('aria-hidden', 'true');
      document.documentElement.style.overflow = '';
    }

    // Open from the main gallery image — start at the currently-active thumb.
    var main = document.querySelector('[data-wally-zoom]');
    function currentThumbIndex() {
      var thumbs = document.querySelectorAll('[data-wally-gallery-thumb]');
      for (var i = 0; i < thumbs.length; i++) { if (thumbs[i].classList.contains('is-active')) return i; }
      return 0;
    }
    if (main) {
      main.addEventListener('click', function () { open(currentThumbIndex()); });
      main.addEventListener('keydown', function (e) { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); open(currentThumbIndex()); } });
    }

    lb.querySelector('[data-lb-close]').addEventListener('click', close);
    lb.querySelector('[data-lb-prev]').addEventListener('click', function () { show(idx - 1); });
    lb.querySelector('[data-lb-next]').addEventListener('click', function () { show(idx + 1); });
    lb.addEventListener('click', function (e) { if (e.target === lb || e.target.classList.contains('wally2-lightbox__stage')) close(); });
    document.addEventListener('keydown', function (e) {
      if (lb.hidden) return;
      if (e.key === 'Escape') close();
      else if (e.key === 'ArrowLeft') show(idx - 1);
      else if (e.key === 'ArrowRight') show(idx + 1);
    });
  })();

  // ── GWU videos: click-to-play (no native controls; centered play button) ──
  document.querySelectorAll('[data-wally-video]').forEach(function (wrap) {
    var video = wrap.querySelector('video');
    if (!video) return;
    wrap.addEventListener('click', function () {
      if (video.paused) { video.play(); } else { video.pause(); }
    });
    video.addEventListener('play', function () { wrap.classList.add('is-playing'); });
    video.addEventListener('pause', function () { wrap.classList.remove('is-playing'); });
    video.addEventListener('ended', function () { wrap.classList.remove('is-playing'); video.currentTime = 0; });
  });

  // ── Plant grid: category filter + responsive 2-row collapse ──
  // Markup: [data-wally-plant-grid] containing [data-wally-filter] tab buttons,
  //   [data-wally-plant-cards] with .plant-card[data-category] items, and an
  //   optional [data-wally-plant-toggle] show-more button.
  document.querySelectorAll('[data-wally-plant-grid]').forEach(function (grid) {
    var tabs = grid.querySelectorAll('[data-wally-filter]');
    var cards = Array.prototype.slice.call(grid.querySelectorAll('.plant-card'));
    var toggle = grid.querySelector('[data-wally-plant-toggle]');
    if (!cards.length) return;
    var current = 'all';
    var expanded = false;

    function rowLimit() {
      var w = window.innerWidth;
      if (w >= 1400) return 14;
      if (w >= 981) return 12;
      if (w >= 721) return 8;
      if (w >= 481) return 6;
      return 4;
    }

    function render() {
      var visible = cards.filter(function (c) {
        return current === 'all' || c.getAttribute('data-category') === current;
      });
      cards.forEach(function (c) { c.classList.add('is-hidden'); c.classList.remove('is-overflow'); });
      var limit = rowLimit();
      visible.forEach(function (c, i) {
        c.classList.remove('is-hidden');
        if (!expanded && i >= limit) c.classList.add('is-overflow');
      });
      if (toggle) {
        var overflow = visible.length > limit;
        toggle.style.display = overflow ? '' : 'none';
        var label = toggle.querySelector('[data-wally-plant-toggle-label]') || toggle;
        label.textContent = expanded ? 'Show fewer plants' : 'Show more plants';
        toggle.setAttribute('aria-expanded', expanded ? 'true' : 'false');
      }
    }

    tabs.forEach(function (tab) {
      tab.addEventListener('click', function () {
        current = tab.getAttribute('data-wally-filter') || 'all';
        expanded = false;
        tabs.forEach(function (t) { t.classList.toggle('grow__tab--active', t === tab); });
        render();
      });
    });
    if (toggle) toggle.addEventListener('click', function () { expanded = !expanded; render(); });

    var rt;
    window.addEventListener('resize', function () { clearTimeout(rt); rt = setTimeout(render, 120); });
    render();
  });
})();
